import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { ArrowForwardIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { NavigationButton } from '@/navigation/components/NavigationButton';
import type { NavigationItemProps } from '@/navigation/types/navigation';

const styles = StyleSheet.create({
  icon: { marginRight: -12 },
  buttonContent: { flexDirection: 'row-reverse', gap: 8 },
  buttonLabel: { margin: 4, marginRight: 4, marginLeft: 8 }
});

export const SectionNavigationButton: FC<NavigationItemProps> = (props) => {
  const { t } = useTranslation(LocalizationNameSpace.START, {
    keyPrefix: 'components'
  });

  return (
    <NavigationButton
      {...props}
      icon={({ color, size }) => (
        <ArrowForwardIcon
          width={size}
          height={size}
          fill={color}
          style={styles.icon}
        />
      )}
      contentStyle={styles.buttonContent}
      labelStyle={styles.buttonLabel}
    >
      {t('more')}
    </NavigationButton>
  );
};
